module.exports = __webpack_public_path__ + "./images/white-portret.jpg?e1449663fb9b25184dc409e6f680a261";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/white-portret.jpg
// module id = 98
// module chunks = 0